/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Choose_Folder_ButtonInputs */

const en_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Export Folder`)
};

const fr_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir le dossier d'exportation`)
};

const de_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportordner auswählen`)
};

const it_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli la cartella di esportazione`)
};

const ru_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите папку экспорта`)
};

const es_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar carpeta de exportación`)
};

const zh_cn2_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择导出文件夹`)
};

const ja_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートフォルダを選択`)
};

const hi_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात फ़ोल्डर चुनें`)
};

const pt_pt2_video_export_choose_folder_button = /** @type {(inputs: Video_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a pasta de exportação`)
};

/**
* | output |
* | --- |
* | "Choose Export Folder" |
*
* @param {Video_Export_Choose_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_choose_folder_button = /** @type {((inputs?: Video_Export_Choose_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Choose_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_choose_folder_button(inputs)
	if (locale === "de") return de_video_export_choose_folder_button(inputs)
	if (locale === "it") return it_video_export_choose_folder_button(inputs)
	if (locale === "ru") return ru_video_export_choose_folder_button(inputs)
	if (locale === "es") return es_video_export_choose_folder_button(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_choose_folder_button(inputs)
	if (locale === "ja") return ja_video_export_choose_folder_button(inputs)
	if (locale === "hi") return hi_video_export_choose_folder_button(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_choose_folder_button(inputs)
	return en_video_export_choose_folder_button(inputs)
});